import { Button, Container, Form, FormField } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useStore } from '../../../store';
const _preserve = React.version;



export const DownloadsMovementsPage = () => {
    const { menu, parameters } = useGlobalState();


    const {
        actions: { makeHelpPanelHandler },
    } = useStore();

    const [movements, setMovements] = useState<ItemsMovement[]>([]);




    useEffect(() => {
        //handleRefreshMovements();
    }, [parameters.month]); //parameters.startDate, parameters.endDate, 

    useEffect(() => {

    }, [parameters]);



    const handleRefreshMovements = async () => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.period) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        month: parameters.period.split("-")[1],
                        year: parameters.period.split("-")[0],
                        orderBy: "dateTransaction",
                        order: "desc",
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK"

                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    if (data.movements.length > 0) {
                        const ws = XLSX.utils.json_to_sheet(data.movements);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Movements");
                        XLSX.writeFile(wb, `Movimientos.${parameters.period}.xlsx`);
                    }
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }

    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header actions={<Favorites />}>
                            Descarga de archivo de movimientos
                        </Header>
                        <Container>
                            <Form actions={<>
                                <Button onClick={handleRefreshMovements} disabled={!parameters.period || parameters.period === ""}>Exportar a Excel</Button>
                            </>}>
                                <FormField label="Periodo">
                                    <div style={{ width: 130 }}>
                                        <MPModal
                                            width={120}
                                            today prevMonth nextMonth
                                            end={new Date()}
                                            date={`${parameters.period}`}
                                            onConfirm={(date) => {
                                                setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                            }}
                                        />
                                    </div>
                                </FormField>
                            </Form>
                        </Container>
                    </SpaceBetween>
                </>
            }
        />
    );
};
